import { makeStyles } from "tss-react/mui";
import { Theme } from "@mui/material";

export enum SeparatorType {
  OrderStart = "OrderStart",
  PriorToOrder = "PriorToOrder",
  AfterOrder = "AfterOrder",
}

type OptionalString = string | undefined;

interface ISeparatorConfigs {
  backgroundColor: OptionalString;
  borderColor: OptionalString;
  fontColor: OptionalString;
}

const separatorConfigs = (
  theme: Theme
): { [key: string]: ISeparatorConfigs } => ({
  [SeparatorType.OrderStart]: {
    backgroundColor: theme.palette.primary.medium,
    borderColor: theme.palette.cyan.dark,
    fontColor: theme.palette.primary.contrastText,
  },
  [SeparatorType.PriorToOrder]: {
    backgroundColor: theme.palette.info.main,
    borderColor: theme.palette.lightblue.main,
    fontColor: theme.palette.info.contrastText,
  },
  [SeparatorType.AfterOrder]: {
    backgroundColor: theme.palette.success.main,
    borderColor: theme.palette.green.main,
    fontColor: theme.palette.success.contrastText,
  },
});

export const getSeparatorConfig = (
  x: number,
  isFlow?: boolean
): { title: string; type: SeparatorType } => {
  const title = isFlow ? "Flow" : "Order";

  if (x === 0) {
    return {
      title: `${title} start`,
      type: SeparatorType.OrderStart,
    };
  }
  if (x > 0) {
    return {
      title: `${x} day${x > 1 ? "s" : ""} after ${title}${
        isFlow ? " start" : ""
      }`,
      type: SeparatorType.AfterOrder,
    };
  }

  return {
    title: `${x * -1} day${Math.abs(x) > 1 ? "s" : ""} prior to ${title}${
      isFlow ? " start" : ""
    }`,
    type: SeparatorType.PriorToOrder,
  };
};

export const Separator = ({
  title,
  type = SeparatorType.OrderStart,
}: {
  title: string;
  type: SeparatorType;
}) => {
  const { classes } = useStyles({ type });

  return <div className={classes.mainContainer}>{title}</div>;
};

const useStyles = makeStyles<{ type: SeparatorType }>()((theme, { type }) => {
  const config = separatorConfigs(theme)[type];
  return {
    mainContainer: {
      background: config.backgroundColor,
      border: `1px solid ${config.borderColor}`,
      borderRadius: theme.spacing(1),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(1),
      color: config.fontColor,
      fontWeight: theme.fontWeight.light,
      fontSize: theme.fontSize.small,
    },
  };
});
